var map = {
	"./calificacion/calificacion.module": [
		"./src/app/calificacion/calificacion.module.ts",
		"default~calificacion-calificacion-module~dashboard-dashboard-module~pedidos-pedidos-module~reporte-r~f950e55d",
		"common",
		"calificacion-calificacion-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"default~calificacion-calificacion-module~dashboard-dashboard-module~pedidos-pedidos-module~reporte-r~f950e55d",
		"common",
		"dashboard-dashboard-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./menu/menu.module": [
		"./src/app/menu/menu.module.ts",
		"menu-menu-module"
	],
	"./modal-editar-afes/modal-editar-afes.module": [
		"./src/app/modal-editar-afes/modal-editar-afes.module.ts"
	],
	"./pedidos/pedidos.module": [
		"./src/app/pedidos/pedidos.module.ts",
		"default~calificacion-calificacion-module~dashboard-dashboard-module~pedidos-pedidos-module~reporte-r~f950e55d",
		"common",
		"pedidos-pedidos-module"
	],
	"./reporte/reporte.module": [
		"./src/app/reporte/reporte.module.ts",
		"default~calificacion-calificacion-module~dashboard-dashboard-module~pedidos-pedidos-module~reporte-r~f950e55d",
		"common",
		"reporte-reporte-module"
	],
	"./signup/signup.module": [
		"./src/app/signup/signup.module.ts",
		"signup-signup-module"
	],
	"./solicitud/solicitud.module": [
		"./src/app/solicitud/solicitud.module.ts",
		"default~calificacion-calificacion-module~dashboard-dashboard-module~pedidos-pedidos-module~reporte-r~f950e55d",
		"common",
		"solicitud-solicitud-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;